import CES2025 from '@elem/compPage/CES2025';
import { ProductProvider } from '@elem/compPage/chat/ProductProvider';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/ces2025';
import getLocal from '@/app/utils/i18n';
import { GetServerSidePropsContext } from 'next';
import { redirectTo404 } from '@/utils';
import { IPageStatus } from '@elem/compPage/chat/config/IPageStatus';
import PageChat from '@elem/compPage/chat';
import { useGlobal } from '@/utils/useGlobal';
import BhStatCommonA from '@/appComps/BhStatCommonA';

const whiteLocaleList = ['us', 'ca', 'eu', 'de', 'jp', 'uk', 'fr', 'za', 'au', 'cn'];

export default function Chat({ SEO, timeLine, pageStatus }: any) {
    const { locale } = getLocal();

    const initState = {
        timeLine,
        pageStatus,
    };

    const { textIdA1, globalTimestamp } = useGlobal();

    return (
        <>
            <SEO title={'Intelligent Assistant Chat'} description={'Intelligent Assistant Chat'} />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={seoconfig.url} />
            <ProductProvider state={initState}>
                <PageChat />
                <BhStatCommonA systemTimestamp={globalTimestamp} textIdA1={textIdA1} />
            </ProductProvider>
        </>
    );
}
export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    console.log(locale, query);
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/chat/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/chat/config/times/us.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    // 时间节点判断 正式环境未开始重定向404
    const time = new Date().getTime(); // 服务器时区北京时区

    let currentTime = time;
    let pageStatus = IPageStatus.statusA;

    if (_timer) {
        currentTime = new Date(`${_timer} GMT+8`).getTime();
    }

    if (timeLine) {
        if (currentTime >= timeLine.statusA.start) {
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }
    if (debug && !_timer) {
        if (debug === IPageStatus.statusA) {
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }

    return {
        props: {
            timeLine: timeLine,
            pageStatus: pageStatus,
        },
    };
}
